export default "__VITE_ASSET__CWMSRaJb__"